<template>
  <div class="modal-base">
    <Transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
      @after-leave="onBgFadeAnimAfterLeave"
    >
      <!-- Key event not needed since child modal components should implement a proper close button. -->
      <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
      <div
        v-if="isActive"
        class="modal-bg"
        @click.stop="onBgClick"
      />
    </Transition>
    <Transition
      mode="in-out"
      :enter-active-class="`animate__animated animate__${enterAnim} animate__faster`"
      :leave-active-class="`animate__animated animate__${leaveAnim} animate__faster`"
    >
      <div
        v-if="isActive"
        class="modal"
      >
        <slot :hide="hide" />
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'ModalBase',

  props: {
    enterAnim: { type: String, default: 'fadeInDown' },
    leaveAnim: { type: String, default: 'fadeOutUp' }
  },

  data() {
    return {
      isActive: false
    };
  },

  mounted() {
    setTimeout(() => this.show(), 10);
  },

  methods: {
    show() {
      this.isActive = true;
    },

    hide() {
      this.isActive = false;
    },

    onBgClick() {
      this.hide();
    },

    onBgFadeAnimAfterLeave() {
      this.$emit('hide');
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-base {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgb(0 0 0 / 75%);
}

.modal {
  position: relative;
  z-index: 2;
}
</style>
